import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GuiThongTinLienHe from "./sections/GuiThongTinLienHe.tsx";
import HeadquartersInformation from "./sections/HeadquartersInformation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <HeadquartersInformation />
      <GuiThongTinLienHe />
      <Footer />
    </div>;
}